import Backbone from "backbone";
import {isMobile, isTouch} from "../others/Configuration";
import extractIdFromYouTubeUrl from "../../../../Nav/Js/utils/extractIdFromYouTubeUrl";
import humanizeTimeStamp from "../../../../Nav/Js/utils/humanizeTimeStamp";
import $ from "jquery";
// import MediaElement from "../../vendors/mediaelement";
import { MediaElementJS } from "../../common/dynamic-imports/MediaElementJS";
import SharedDispatcher from "../others/SharedDispatcher";
import * as PopinPlayerEvents from "../events/popin-player-events";
import * as VisualsViewEvents from "../events/visuals-view-events";

/**
   * Video Player view
   *
   * @todo Block controls while a video is loading to avoid unexpected behaviors
   * @todo Improve toggle fullscreen fluidity
   * @todo Block controls while a video is loaded to avoid unexpected behaviors
   *
   * @property {integer} baseHeight            Video default height
   * @property {integer} baseWidth             Video default width
   * @property {integer} bufferTimer           Interval ID of Buffer timer (which live-update the buffer bar)
   * @property {integer} controlsHeight        Video header and controls height (in pixels)
   *                                           70 = this.$(".js-VideoPlayer-header").height() + this.$(".js-VideoPlayer-controls").height()
   * @property {integer} height                Video current height
   * @property {integer} isDraggingProgressBar Is teh user actually dragging the buffer/volume progress bar ?
   * @property {boolean} isFirstTime           Is this video the first one to be loaded ? (so it's not auto-playing)
   * @property {boolean} isFullScreen          Is video in full screen ?
   * @property {boolean} isMuted               Is sound muted ?
   * @property {boolean} isPlaying             Is the video playing ?
   * @property {boolean} playlistIsVisible     Is playlist visible ?
   * @property {float}   progressBarWidth      Progress bar width (in pixels)
   * @property {string}  source                Video source: "Fnac", "YouTube"
   * @property {string}  title                 "timeupdate" event firing rate
   * @property {string}  videoCount            Number of videos in the playlist
   * @property {string}  videoId               "timeupdate" event firing rate
   * @property {string}  videoIndex            Current video index in the playlist
   * @property {string}  videoThumbnail        Current video thumbnail URL
   * @property {string}  videoUrl              Current video URL (deported here because of YT binding)
   * @property {float}   volume                Current volume
   * @property {float}   volumeBarWidth        Volume bar width (in pixels)
   * @property {integer} width                 Current width
   * @property {string}  youTubePattern        Regular expression to detect a YouTube video URL
   * @property {integer} youTubeTimer          Interval ID of YouTube timer (which live-update the timer in controls)
   *
   * @property {object}  $selectedItem         jQuery wrapped selected item node in the playlist
   * @property {object}  $video                jQuery wrapped <video>, <iframe> or <object> node
   */
  export default Backbone.View.extend({
    /**
     * Constructor
     *
     * @todo Where to put the resize event listener ?
     */
    initialize: function () {
      this.hideControls = this.hideControls.bind(this);
      this.onFullScreenModeChange = this.onFullScreenModeChange.bind(this);
      this.onPlayerReady = this.onPlayerReady.bind(this);
      this.onVideoEnded = this.onVideoEnded.bind(this);
      this.onProgressMouseUp = this.onProgressMouseUp.bind(this);
      this.onProgressTouchStart = this.onProgressTouchStart.bind(this);
      this.onProgressTouchMove = this.onProgressTouchMove.bind(this);
      this.onProgressTouchEnd = this.onProgressTouchEnd.bind(this);
      this.onVolumeMouseUp = this.onVolumeMouseUp.bind(this);
      this.onYouTubeVideoReady = this.onYouTubeVideoReady.bind(this);
      this.onYouTubeVideoStateChanged = this.onYouTubeVideoStateChanged.bind(this);
      this.playAt = this.playAt.bind(this);
      this.playerReset = this.playerReset.bind(this);
      this.render = this.render.bind(this);
      this.renderError = this.renderError.bind(this);
      this.resize = this.resize.bind(this);
      this.setProgressBar = this.setProgressBar.bind(this);
      this.getOffsetX = this.getOffsetX.bind(this);
      this.setVolume = this.setVolume.bind(this);
      this.showControls = this.showControls.bind(this);
      this.togglePlaylist = this.togglePlaylist.bind(this);
      this.togglePlay = this.togglePlay.bind(this);
      this.updateProgressBar = this.updateProgressBar.bind(this);

      this.baseWidth = this.$el.width();
      this.baseHeight = Math.min(Math.round(9 * this.baseWidth / 16), 360);
      this.bufferTimer = 0;
      this.controlsHeight = 70;
      this.height = 0;
      this.isDraggingProgressBar = false;
      this.isFirstTime = true;
      this.isFullScreen = false;
      this.isMuted = false;
      this.isPlaying = false;
      this.playlistIsVisible = false;
      this.progressBarWidth = 0;
      this.source = "Fnac";
      this.title = null;
      this.videoCount = this.$(".js-VideoPlayerPlaylist-item").length;
      this.videoId = this.cid + "-video"; // MediaElement and YouTube API need an Id !
      this.videoIndex = -1;
      this.videoThumbnail = null;
      this.videoUrl = 0;
      this.videoUrlAdvertising = 0;
      this.volume = 0.5;
      this.volumeBarWidth = 0;
      this.width = this.baseWidth;
      this.youTubePattern = /.*(youtu\.be|youtube\.com).*/i;
      this.youTubeTimer = 0;

      this.$progressBar = this.$(".js-VideoPlayerControls-progressBar");
      this.$progressBarPlayed = this.$(".js-VideoPlayerControls-progressBarPlayed");
      this.$volumeBar = this.$(".js-VideoPlayerControls-volumeBar");
      this.$selectedItem = null;
      this.$video = null;

      this.preRender();
      this.loadVideo();

      this.fullScreenMode = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || (document.msFullscreenElement && document.msFullscreenElement !== null); // This will return true or false depending on if it's full screen or not.
      $(document).on("webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange", this.onFullScreenModeChange);
      this.listenTo(SharedDispatcher, PopinPlayerEvents.BEFORE_CLOSE, this.onBeforeClosePopinPlayer);
      this.listenTo(SharedDispatcher, VisualsViewEvents.ON_CHANGE, this.onVisualsViewChange);
    },

    events: {
      "click     .js-VideoPlayerPlaylist-item"            : "loadVideo",
      "click     .js-VideoPlayerPlaylist-toggle"          : "togglePlaylist",
      "click     .js-VideoPlayer-glass"                   : "togglePlay",
      "dblclick  .js-VideoPlayer-glass"                   : "toggleFullScreen",
      "click     .js-VideoPlayerControls-next"            : "playNext",
      "click     .js-VideoPlayerControls-previous"        : "playPrevious",
      "mousedown .js-VideoPlayerControls-progressBar"     : "onProgressMouseDown",
      "touchstart .js-VideoPlayerControls-progressBar"    : "onProgressTouchStart",
      "click     .js-VideoPlayerControls-toggleFullScreen": "toggleFullScreen",
      "click     .js-VideoPlayerControls-toggleMute"      : "toggleMute",
      "click     .js-VideoPlayerControls-togglePlay"      : "togglePlay",
      "mousedown .js-VideoPlayerControls-volumeBar"       : "onVolumeMouseDown",
      "touchstart .js-VideoPlayerControls-volumeBar"      : "onVolumeTouchStart"
    },

    /**
     * Load a new video from the playlist
     *
     * @param {object} event
     * @param {object} videoIndex Video index to be played
     */
    loadVideo: function(event, videoIndex) {
      // We get the playlist video node depending on the case :
      // 1. The user clicked on a video within the playlistsound
      // 2. The method is called with a specific video index
      // 3. By default, we play the first one
      if (event) {
        this.$selectedItem = this.$(event.currentTarget);
      } else if (videoIndex) {
        this.$selectedItem = this.$('.js-VideoPlayerPlaylist-item[data-video-index="' + videoIndex + '"]');
      } else {
        this.$selectedItem = this.$(".js-VideoPlayerPlaylist-item").first();
      }

      // If the video asked is the same than the current video
      if (!videoIndex && this.$selectedItem.data("video-index") == this.videoIndex) {
        return;
      }

      // If the playlist is opened, we close it
      // (we do that here to avoid a lag effect when the user select a video from the playlist)
      if (this.playlistIsVisible) {
        this.togglePlaylist();
      }

      // If the player is currently playing, we stop it
      if (this.isPlaying) {
        this.togglePlay();
      }

      if (!this.isFirstTime) {
        // If it was a YouTube video
        if (this.source === "YouTube") {
          // We stop the timer
          window.clearInterval(this.youTubeTimer);

          // We destroy the DOM
          this.player.destroy();

        // If it was a Fnac video, we destroy the DOM
        } else {
          this.$("object").length ? this.player.remove() : $('.js-VideoPlayer-videoContainer').empty();
        }
      }

      this.height = this.width * this.$selectedItem.data("video-0-height") / this.$selectedItem.data("video-0-width");
      this.title = this.$selectedItem.find(".js-VideoPlayerPlaylist-itemTitle").text();
      this.videoIndex = this.$selectedItem.data("videoIndex");
      this.videoUrl = this.$selectedItem.data("video-0-url");

      // We update the poster
      this.$('.js-VideoPlayer-poster').attr("data-lazyimage-background", this.$selectedItem.data("videoThumbnail")).addClass("js-LazyImage");

      // If this is a YouTube video
      if (this.youTubePattern.test(this.videoUrl)) {
        this.source = "YouTube";
        this.$(".js-VideoPlayer-videoContainer").html('<div id="' + this.videoId + '"></div>');
        this.loadYouTubeVideo();

      // If this is a Fnac video
      } else {
        // We check if the video resource exists (via its HTTP response)
        // @see http://stackoverflow.com/questions/18410051/how-does-mediaelement-handle-missing-files
        // @todo It doesn't work since "Access-Control-Allow-Origin" headers are not set up on media files
        /*var response = $.ajax({ async: false, type: "HEAD", url: this.videoUrl });
        if (parseInt(response.status / 100) !== 2) {
        this.renderError();
        return;
        }*/

        this.source = "Fnac";
        this.loadPlayerHtml();
        this.$video = this.$("video");
        this.loadPlayer();
      }
    },

    /**
    * Fired when Video is over
    */
    onVideoEnded: function (event) {
        if (this.$selectedItem.data("video-" + this.$selectedItem.data("video-index") + "-advertising-url")) {
            if (this.videoUrlAdvertising == 0) {
                this.videoUrlAdvertising = this.$selectedItem.data("video-" + this.$selectedItem.data("video-index") + "-advertising-url");
                this.player.setSrc(this.videoUrlAdvertising);
                this.player.load();
                this.player.play();
                this.togglePlay(true);
            } else {
                this.videoUrlAdvertising = 0;
                this.player.setSrc(this.videoUrl);
                this.player.load();
                this.player.play();
            }
        }
    },

    loadPlayerHtml: function() {
      // We set the video ID for MediaElement & YouTube API
      var videoSource = '<video id="' + this.videoId + '">';
      var index = 0, indexMax = this.$selectedItem.data("video-count");
      for (var index = 0; index < indexMax; index++) {
        videoSource += '<source type="' + this.$selectedItem.data("video-" + index + "-mime-type") + '" src="' + this.$selectedItem.data("video-" + index + "-url") + '">'
      }
      videoSource += '</video>';

      this.$(".js-VideoPlayer-videoContainer").html(videoSource);
    },

    /**
     * Load the MediaElement Player
     */
    loadPlayer: function () {
      /**
       * MediaElement Video Player
       *
       * @see http://mediaelementjs.com/#api
       *
       * @property {string}  defaultVideoHeight    Video height if height attribute is not specified
       * @property {string}  defaultVideoWidth     Video width if width attribute is not specified
       * @property {string}  enablePluginSmoothing Fix IE Flash plugin rendering quality issues
       *                                           @see http://stackoverflow.com/questions/17665184/video-quality-issues-with-mediaelement-js-and-flash
       * @property {string}  flashName             Name of Flash plugin file
       * @property {integer} pluginHeight          Overrides video height attribute
       * @property {string}  pluginPath            Path to plugins (Flash, Silverlight, etc)
       * @property {string}  pluginWidth           Overrides video width attribute
       * @property {array}   plugins               Set and order plugins priority
       * @property {string}  silverlightName       Name of Silverlight plugin file
       * @property {string}  timerRate             "timeupdate" event firing rate
       */
      const mediaElementJS = new MediaElementJS(this.videoId, {
        defaultVideoHeight: this.height,
        defaultVideoWidth: this.width,
        plugins: [],
        timerRate: 250,

        success: this.onPlayerReady,
        error: this.renderError
      });
      mediaElementJS.run().then(instance => this.player = instance);
    },

    /**
     * Fired when MediaElement player is ready
     *
     * @param  {object} mediaElement DOM object wrapped with MediaElement methods and properties
     * @param  {object} domObject    Pure DOM object (<video>)
     *
     * @todo Do a setInterval for updateBufferBar()
     */
    onPlayerReady: function (mediaElement, domObject) {
      this.$mediaElement = $(mediaElement);
      this.$video = this.$("object").length ? this.$("object") : $(domObject);

      this.$mediaElement.on("ended", e => {
          this.onVideoEnded(e);
          this.togglePlay(e);
      });
      this.$mediaElement.one("loadedmetadata", this.render);
      this.$mediaElement.on("progress timeupdate", this.updateProgressBar);

      // For Flash fallback: we force the plugin to load the video,
      // so "loadedmetadata" event is triggered, thus the render() too
      if (this.$("object").length) {
        this.togglePlay();
        window.setTimeout(this.playerReset, 1000);
      }

      // We reset the volume
      mediaElement.setVolume(this.volume);
    },

    onFullScreenModeChange: function () {
      if (this.fullScreenMode) {
        this.isFullScreen = true;
        this.exitFullScreen();
      }
      this.fullScreenMode = !this.fullScreenMode;
    },

    /**
     * Hack to avoid the triple action "play + pause + play" needed to play the video for the first time
     * with a "stop" effect (do not use the MediaElement stop() method which doesn't work in this case)
     */
    playerReset: function() {
      this.togglePlay();
      this.player.setCurrentTime(0);
    },

    /**
     * Load a new YouTube video (from the playlist)
     *
     * @see https://developers.google.com/youtube/iframe_api_reference
     *      https://developers.google.com/youtube/player_parameters?playerVersion=HTML5
     *      http://stackoverflow.com/questions/886864/differences-between-using-wmode-transparent-opaque-or-window-for-an-embe
     *
     * @todo Set "wmode": "transparent" only for IE ? (because it's heavier)
     */
    loadYouTubeVideo: function() {
      if (window.onYouTubeIframeAPIReady) {
        window.onYouTubeIframeAPIReady();
        return;
      }

      window.onYouTubeIframeAPIReady = () => {
        this.player = new YT.Player(this.videoId, {
          height: this.baseHeight,
          width: this.baseWidth,
          videoId: extractIdFromYouTubeUrl(this.videoUrl),
          playerVars: {
            "autoplay": 0,
            "controls": 0,
            "modestbranding": 0,
            "rel": 0,
            "showinfo": 0,
            "wmode": "transparent" // For IE overlaying
          },
          events: {
            "onReady": this.onYouTubeVideoReady,
            "onError": function(error) { console.error(error); },
            "onStateChange": this.onYouTubeVideoStateChanged
          }
        });
      };

      // We loads the Google IFrame Player API code asynchronously
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";

      $("body").append(tag);
    },

    /**
     * Set YouTube player settings once video is loaded
     */
    onYouTubeVideoReady: function() {
      this.$video = this.$("iframe");

      this.player.duration = this.player.getDuration();
      this.player.setVolume(this.volume * 100);

      // We start the timer
      this.youTubeTimer = window.setInterval(this.updateProgressBar, 250);

      this.render();
    },

    /**
     * Manage the various event states sent by the YouTube player
     */
    onYouTubeVideoStateChanged: function(event) {
      switch (event.data) {
        case YT.PlayerState.ENDED:
          this.togglePlay(false);
          break;

        case YT.PlayerState.PLAYING:
          this.$(".js-VideoPlayerControls-togglePlay").addClass("play--active");
          break;

        case YT.PlayerState.PAUSED:
          this.$(".js-VideoPlayerControls-togglePlay").removeClass("play--active");
          break;
      }
    },

    /**
     * Show controls, playlist and header
     */
    showControls: function() {
      this.$(".js-VideoPlayer-header, .js-VideoPlayer-controls").stop().fadeIn();

      if (this.videoCount > 1) {
        this.$(".js-VideoPlayer-playlist").stop().fadeIn();
      }
    },

    /**
     * Hide controls, playlist and header
     */
    hideControls: function() {
      this.$(".js-VideoPlayer-header, .js-VideoPlayer-controls").stop().fadeOut();

      if (this.videoCount > 1) {
        this.$(".js-VideoPlayer-playlist").stop().fadeOut();
      }
    },

    /**
     * Show/Hide the playlist
     */

    togglePlaylist: function () {
      this.$(".js-VideoPlayerPlaylist-list").toggleClass("VideoPlayerPlaylist-list--active").exit();
      //this.playlistIsVisible = !this.playlistIsVisible;
    },

    /**
     * Play/Pause the video
     */
    togglePlay: function () {
      switch (this.source) {
        case "Fnac":
          this.isPlaying ? this.player.pause() : this.player.play();
          break;

        case "YouTube":
          this.isPlaying ? this.player.pauseVideo() : this.player.playVideo();
          break;
      }

      if (this.isPlaying) {
        this.$(".js-VideoPlayerControls-togglePlay").removeClass("play--active");
        this.$(".js-VideoPlayer-glass").addClass("VideoPlayer-glass--paused");
      } else {
        this.$(".js-VideoPlayerControls-togglePlay").addClass("play--active");
        this.$(".js-VideoPlayer-glass").removeClass("VideoPlayer-glass--paused");
      }

      this.isPlaying = !this.isPlaying;

      if (this.$(".js-VideoPlayer-poster").length) {
        this.$(".js-VideoPlayer-poster").remove();
      }
    },

    /**
     * Pause the video
     */
    pause: function () {
      if (this.isPlaying) {
        this.source === "Fnac" ? this.player.pause() : this.player.pauseVideo();
        this.player.pause();
        this.$(".js-VideoPlayerControls-togglePlay").removeClass("play--active");
        this.$(".js-VideoPlayer-glass").addClass("VideoPlayer-glass--paused");
        this.isPlaying = false;
      }
    },

    /**
     * When before popin player close
     * @param {{videoId: string}} data
     * When popin player is closed we pause the video
     */
    onBeforeClosePopinPlayer: function (data) {
      if (data.videoId === this.videoId) {
        this.pause();
      }
    },

    /**
     * When a visuals view changed
     * @param {{videoId: string, type: 'image'|'video'}} data
     */
    onVisualsViewChange: function (data) {
      // when image is selected we need to pause video
      if (data.type === 'image' && data.videoId === this.videoId) {
        this.pause();
      }
    },

    /**
     * Play from a specific timestamp (specific method adapted to rangeslider.js "onSlide" event callback)
     *
     * @param {object} Event
     */
    playAt: function (event) {
      var timestamp = parseInt(this.player.duration * this.getOffsetX(event) / this.progressBarWidth);

      switch (this.source) {
        case "Fnac":
          this.player.setCurrentTime(timestamp);
          break;

        case "YouTube":
          this.player.seekTo(timestamp, true);
          break;
      }
    },

    /**
     * Play previous video of the playlist
     */
    playPrevious: function() {
      this.videoIndex = (this.videoIndex === 1) ? this.videoIndex = this.videoCount : this.videoIndex - 1;
      this.loadVideo(false, this.videoIndex);
    },

    /**
     * Play next video of the playlist
     */
    playNext: function() {
      this.videoIndex = (this.videoIndex === this.videoCount) ? 1 : this.videoIndex + 1;
      this.loadVideo(false, this.videoIndex);
    },

    /**
     * Mute/Unmute the sound
     */
    toggleMute: function() {
      switch (this.source) {
        case "Fnac":
          this.isMuted ? this.player.setMuted(false) : this.player.setMuted(true);
          break;

        case "YouTube":
          this.isMuted ? this.player.unMute() : this.player.mute();
          break;
      }
      if (!this.isMuted) {
        this.$(".js-VideoPlayerControls-toggleMute").addClass("mute--active");
        this.$(".js-VideoPlayerControls-volumeBarFill").addClass("VideoPlayerControls-volumeBarFill--muted");
      } else {
        this.$(".js-VideoPlayerControls-toggleMute").removeClass("mute--active");
        this.$(".js-VideoPlayerControls-volumeBarFill").removeClass("VideoPlayerControls-volumeBarFill--muted");
      }
      this.isMuted = !this.isMuted;
    },

    onVolumeMouseDown: function(event) {
      this.setVolume(event);

      this.$volumeBar.on("mousemove", this.setVolume);
      this.$volumeBar.one("mouseup mouseleave", this.onVolumeMouseUp);
    },

    onVolumeMouseUp: function(event) {
      this.$volumeBar.off("mousemove");
    },

    /**
     * Set the volume
     *
     * @param {object} Event
     */
    setVolume: function(event) {
      var volumePercentage = this.getOffsetX(event) / this.volumeBarWidth;

      // If the sound is muted, we unmute it to avoid unexpected behaviors
      if (this.isMuted) {
        this.toggleMute();
      }

      switch (this.source) {
        case "Fnac":
          this.player.setVolume(volumePercentage);
          break;

        case "YouTube":
          this.player.setVolume(volumePercentage * 100);
          break;
      }

      this.volume = volumePercentage;

      this.$(".js-VideoPlayerControls-volumeBarFill").width(this.volumeBarWidth * volumePercentage);
    },

    /**
     * Toggle full screen mode
     *
     * @todo Check YouTube case : is seeking necessary ?
     */
    toggleFullScreen: function () {
      this.isFullScreen ? this.exitFullScreen() : this.enterFullScreen();
    },

    /**
     * Are we in full-screen mode ?
     *
     * @see http://stackoverflow.com/questions/2863351/checking-if-browser-is-in-fullscreen
     *
     * @return {Boolean}
     */
    windowIsFullScreen: function() {
      return (!window.screenTop && !window.screenY);
    },

    /**
     * Enter full screen mode
     *
     * @todo Create a fullscreen factory
     */
    enterFullScreen: function () {
      if (this.isFullScreen) {
        return;
      }

      this.isFullScreen = true;

      // We apply the full screen mode on the container (and not the <video>) to be able to show the controls
      if (this.el.requestFullscreen) {
        this.el.requestFullscreen();
      } else if (this.el.msRequestFullscreen) {
        this.el.msRequestFullscreen();
      } else if (this.el.mozRequestFullScreen) {
        this.el.mozRequestFullScreen();
      } else if (this.el.webkitRequestFullscreen) {
        this.el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);

      // For IE < 11 (because msRequestFullscreen() doesn't exists)
      } else {
        // If we are not already in fullscreen
        if (!this.windowIsFullScreen()) {
          // We force the fullscreen mode by triggering the F11 key
          try {
            var wscript = new ActiveXObject("Wscript.shell");
            wscript.SendKeys("{F11}");
          } catch (error) {
            console.error(error);
          }
        }

        // For browsers without media support
        if (this.$("object").length) {
          this.height = $(window).height() - this.controlsHeight;
          this.width = $(window).width();

          this.player.setVideoSize(this.width, this.height);
        }
      }

      this.$el.addClass("VideoPlayer--fullscreen");
      this.$(".js-VideoPlayerControls-toggleFullScreen").addClass("fullscreen--active");

      this.resize();
    },

    /**
     * Exit full screen mode
     */
    exitFullScreen: function () {
      if (!this.isFullScreen) {
        return;
      }
      this.isFullScreen = false;

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();

      // For IE < 11 (because msExitFullscreen() doesn't exists)
      } else {
        // If we are in fullscreen
        if (this.windowIsFullScreen()) {
          // We exit the full screen mode by triggering the F11 key
          try {
            var wscript = new ActiveXObject("Wscript.shell");
            wscript.SendKeys("{F11}");
          } catch (error) {
            console.error(error);
          }
        }

        // For browsers without media support
        if (this.$("object").length) {
          this.height = this.baseHeight;
          this.width = this.baseWidth;

          this.player.setVideoSize(this.width, this.height);
        }
      }

      this.$el.removeClass("VideoPlayer--fullscreen");
      this.$(".js-VideoPlayerControls-toggleFullScreen").removeClass("fullscreen--active");

      this.resize();
    },

    onProgressMouseDown: function(event) {
      this.isDraggingProgressBar = true;

      this.setProgressBar(event);
      this.$progressBar.on("mousemove", this.setProgressBar);
      this.$progressBar.one("mouseup mouseleave", this.onProgressMouseUp);
    },

    onProgressMouseUp: function(event) {
      this.isDraggingProgressBar = false;

      this.$progressBar.off("mousemove");

      this.playAt(event);
    },

    setProgressBar: function (event) {
        var progressPercentage = this.getOffsetX(event) / this.progressBarWidth;

        this.$progressBarPlayed.width(this.progressBarWidth * progressPercentage);
    },

     /**
     * Start progress bar on touch start
     *
     * @param {object} Event
     */
    onProgressTouchStart: function (event) {
        this.isDraggingProgressBar = true;

        this.setProgressBar(event);

        this.$progressBar.on("touchmove", this.onProgressTouchMove);
        this.$progressBar.on("touchend", this.onProgressTouchEnd);
    },

    /**
    * Set progress bar on touch move
    *
    * @param {object} Event
    */
    onProgressTouchMove: function (event) {
        var touch = event.originalEvent.touches[0];

        if (touch.clientX <= $(event.currentTarget).offset().left ||
            touch.clientX >= $(event.currentTarget).offset().left + $(event.currentTarget).outerWidth()) {
            this.onProgressTouchEnd(event);
        } else {
            this.setProgressBar(event);
        }
    },

    /**
    * Stop progress on touch end
    *
    * @param {object} Event
    */
    onProgressTouchEnd: function (event) {
        this.isDraggingProgressBar = false;

        this.$progressBar.off("touchmove");

        this.playAt(event);
    },

    /**
    * Return offset X of differents events (mouse, touch)
    *
    * @param {object} Event
    */
    getOffsetX: function (event) {
        if (event.offsetX) return event.offsetX;

        var rect = event.target.getBoundingClientRect();

        return event.originalEvent.changedTouches[0].clientX - rect.left;
    },

    /**
     * Update video progress bar and timer (within the view)
     *
     * @todo Better fix for this.player.getVideoLoadedFraction() not defined ?
     * @todo Better fix for this.player.getCurrentTime not defined ?
     */
    updateProgressBar: function(event) {
      var bufferedRatio;

      switch (this.source) {
        case "Fnac":
          var buffered = event.target.buffered;
          bufferedRatio = buffered.length ? (buffered.end(buffered.length - 1) / event.target.duration) : 0;
          break;

        case "YouTube":
          bufferedRatio = this.player.getVideoLoadedFraction ? this.player.getVideoLoadedFraction() : 0;
          this.player.currentTime = this.player.getCurrentTime ? this.player.getCurrentTime() : 0;
          break;
      }
      
      this.$(".js-VideoPlayerControls-currentTime").text(humanizeTimeStamp(this.player.currentTime));
      this.$(".js-VideoPlayerControls-progressBarLoaded").width(this.progressBarWidth * bufferedRatio);

      if (!this.isDraggingProgressBar) {
        const fractionPlayed = this.player.currentTime / this.player.duration;
        const width = this.progressBarWidth > 0 ? this.progressBarWidth * fractionPlayed : `${100 * fractionPlayed}%`;
        this.$progressBarPlayed.width(width);
      }
    },

    /**
     * Renders the view before the media is loaded (whether it works or not)
     */
    preRender: function () {
      this.$el.css("height", 'initial');
    },

    /**
     * Renders the view
     */
    render: function() {
      // It this is the first view rendering and there is more than one video (in the playlist)
      if (this.isFirstTime && this.videoCount > 1) {
        // We show the playlist controls
        this.$el.addClass("VideoPlayer--withPlaylist");
      }

      // We set the title (header)
      this.$(".js-VideoPlayer-title").text(this.title);

      // We reset the progress bar
      this.$progressBarPlayed.removeClass("style");

      // We set the timer
      this.$(".js-VideoPlayerControls-duration").text(humanizeTimeStamp(this.player.duration));

      // We switch the active video in the playlist
      this.$(".VideoPlayerPlaylist-item--active").removeClass("VideoPlayerPlaylist-item--active");
      this.$selectedItem.addClass("VideoPlayerPlaylist-item--active");

      // If this is NOT the first load, we play the video
      if (!this.isFirstTime) {
        this.togglePlay(true);
      }

      // We positionate elements (video, header & controls)
      this.resize();
    },

    /**
     * Renders the view when an error happened
     */
    renderError: function() {
      this.$el
        .removeAttr("style")
        .addClass("VideoPlayer--hasError")
        .html("La vidéo n'a pas pu être chargée.");
    },

    /**
     * Positionate elements depending on the mode (normal or full screen)
     *
     * @todo When on multiple screens and IE <= 9, screen represents the master screen and not the current one !
     */
    resize: function () {
      // Show controls before getting their positions, if not we got 0 values
      this.$(".js-VideoPlayer-controls").addClass("invisible").show();

      // We reset size properties
      this.baseWidth = this.$el.width();
      this.baseHeight = Math.round(9 * this.baseWidth / 16);
      this.height = (this.baseHeight > 0 ? this.baseHeight : "initial");
      this.width = (this.baseWidth > 0 ? this.baseWidth : "initial");

      this.$el.removeAttr("style");
      this.$video.removeAttr("style");

      if (!this.isFullScreen) {
        this.$video.css({
          height: "initial"
        });

        // Reset the hack to avoid the vertical scrollbar on IE <= 10
        $("body").removeClass("no-scroll");
      } else {
        this.$el.css({
          height: "100%",
          width: window.innerWidth + "px"
        });

        this.$video.css({
          // height: (window.innerHeight - this.controlsHeight) + "px",
          width: window.innerWidth + "px"
        });

        // Hack to avoid the vertical scrollbar on IE <= 10
        $("body").addClass("no-scroll");
      }

      this.progressBarWidth = this.$(".js-VideoPlayerControls-progressBar").width();
      this.volumeBarWidth = this.$(".js-VideoPlayerControls-volumeBar").width();

      this.$mediaElement.trigger("timeupdate");

      if (this.isFirstTime) {
        // this.$el.css("min-height", this.height + this.controlsHeight);
        this.$(".js-VideoPlayer-controls").removeClass("invisible");

        // Detect touch, no-touch device
        if (isTouch) {
          // Always show controls on touch device
          this.showControls();
        } else {
          // We show controls when the user is hovering the player
          this.$el.hover(this.showControls, this.hideControls);
          this.hideControls();
        }

        // When the window is resized, we reset our player size properties
        $(window).resize(this.resize);

        this.isFirstTime = false;
      }

      this.$(".js-VideoPlayer-controls").hide().removeClass("invisible");
    }
  });
